<p-calendar
  [(ngModel)]="date"
  [readonlyInput]="readonlyInput"
  [locale]="locale"
  [inputId]="inputId"
  [dateFormat]="dateFormat"
  [disabled]="disabled"
  [showButtonBar]="showButtonBar"
  [monthNavigator]="monthNavigator"
  [yearNavigator]="yearNavigator"
  [yearRange]="yearRange"
  [maxDate]="maxDate"
  [minDate]="minDate"
  [showTime]="showTime"
  [timeOnly]="timeOnly"
  [stepMinute]="stepMinute"
  [defaultDate]="defaultDate"
  [formatInputMaskType]="formatInputMaskType"
  [styleClass]="styleClass"
  [showSeconds]="showSeconds"
  [showIcon]="showIcon"
  hourFormat="24"
  appPrimeNgCalendarMask
  (onTodayClick)="onTodayClick()"
  (onInput)="onInput($event)"
  (onClearClick)="handleClear()"
  (onBlur)="onBlur($event)"
  (onSelect)="handleSelect($event)"
  class="prime-calendar"
  [placeholder]="placeholder"
>
</p-calendar>
